export enum PflegiaEmployeePageVisitType {
  PflegiaForFriends = 'pflegia_for_friends',
}
